import { _decorator, Component, Node, Slider } from 'cc';
import ValueSelector from '../../Helper/ValueSelector';
import NumberFormatter from '../Label/NumberFormatter';

const { ccclass, property } = _decorator;

enum EventType {
    VALUE_CHANGED = 'VALUE_CHANGED',
}

@ccclass('ValueSlider')
export default class ValueSlider extends Component {
    public static readonly EVENT_TYPE = EventType;

    @property(Slider)
    private readonly slider: Slider = null;

    @property(Node)
    private readonly indicator: Node = null;

    @property(NumberFormatter)
    private readonly valueNumber: NumberFormatter = null;

    @property(NumberFormatter)
    private readonly min: NumberFormatter = null;

    @property(NumberFormatter)
    private readonly max: NumberFormatter = null;

    @property
    private _interactable = true;

    private _valueSelector: ValueSelector<number> = null;
    private _lockSliderProgress = false;

    @property
    public get interactable() {
        return this._interactable;
    }
    public set interactable(value: boolean) {
        if (this._interactable === value) {
            return;
        }
        this._interactable = value;
        this.updateInteractable();
    }

    public get value() {
        return this._valueSelector.value;
    }
    public set value(value: number) {
        this._valueSelector.value = value;
    }

    public get index() {
        return this._valueSelector.currentIdx;
    }
    public set index(index: number) {
        this._valueSelector.currentIdx = index;
    }

    private get handle() {
        return this.slider.handle.node;
    }

    public onLoad() {
        this.slider.node.on(Slider.EventType.SLIDE, this._onSliderValueChanged, this);
        if (this.indicator) {
            this.handle.on(Node.EventType.TOUCH_START, this._showIndicator, this);
            this.handle.on(Node.EventType.TOUCH_END, this._hideIndicator, this);
            this.handle.on(Node.EventType.TOUCH_CANCEL, this._hideIndicator, this);
        }
    }

    public enable(value: boolean) {
        this.slider.enabled = value;
    }

    public init(valueSelector: ValueSelector<number>) {
        this._valueSelector = valueSelector;
        this._valueSelector.on(ValueSelector.EVENT_TYPE.VALUE_CHANGED, this._onValueChanged, this);
        this._onValueChanged(this._valueSelector.value);
        this._updateSliderProgress();
        if (this.min) {
            this.min.value = valueSelector.options[0];
        }
        if (this.max) {
            this.max.value = valueSelector.options[valueSelector.options.length - 1];
        }
    }

    public deinit() {
        if (!this._valueSelector) {
            return;
        }
        this._valueSelector.off(ValueSelector.EVENT_TYPE.VALUE_CHANGED, this._onValueChanged, this);
        this._valueSelector = null;
    }

    protected updateInteractable() {
        if (this.slider) {
            this.slider.enabled = this.interactable;
        }
    }

    private _onSliderValueChanged() {
        const index = Math.round(this.slider.progress * (this._valueSelector.options.length - 1));
        this._lockSliderProgress = true;
        this._valueSelector.currentIdx = index;
        this._lockSliderProgress = false;
    }

    private _onValueChanged(value: number) {
        if (this.valueNumber) {
            this.valueNumber.value = value;
        }
        this._updateSliderProgress();
        this.node.emit(EventType.VALUE_CHANGED, value);
    }

    private _updateSliderProgress() {
        if (this._lockSliderProgress) {
            return;
        }
        this.slider.progress = this._valueSelector.currentIdx / (this._valueSelector.options.length - 1);
    }

    private _showIndicator() {
        this.indicator.active = true;
    }

    private _hideIndicator() {
        this.indicator.active = false;
    }
}
